module.exports = function getResource(label) {
    let resources = {
        gotIt: 'Got it',
        undo: 'Undo'
    };

    return resources[label];
};
